import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"columns-3-wide, layout, third"} maskId="square-filled-radius-0-stroke-1-IconColumns3Wide"><path d="M8 20H2V4H8V20Z" fill="currentColor"/><path d="M15 20H9V4H15V20Z" fill="currentColor"/><path d="M22 20H16V4H22V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumns3Wide;
